// import styled from "styled-components";
import useScreenSize from "hoc/useScreenSize";
import { IWarrantyOnAutoParts } from "api/interfaces/static-pages/warranty-on-auto-parts.type";
import { memo } from "react";
import LandingPageBanner from "../../component/landing-page/LandingPageBanner";
import PageContainer from "../../modules/components/PageContainer";
import ContentIdsComponent from "../../modules/static-pages/content-ids/contentIds";
import { getRelativeImagePath } from "../../util/helper/getRelativeImagePath";
import styles from "./warrant_policy.module.scss";

function WarrantyPolicy(props: IWarrantyOnAutoParts) {
  const response = props.actualResponse.landingPage;
  const { headers, responsiveBannerMedia } = response;
  const { contentIds } = response.links;
  const [isMobile] = useScreenSize();

  // const meta = {
  //   title: "",
  //   description:
  //     "All our Auto Parts are sourced from highly reputed Quality Brands. We offer our own Warranty in addition to Manufacturer warranty, so we have you fully covered",
  //   meta: {
  //     robots: "all",
  //     name: {
  //       title: "PartsAvatar: Warranty on Online Aftermarket Parts",
  //       keywords:
  //         "parts purchase policy,auto part top brands,autoparts warranty,car parts warranty,parts manufacturer warranty,1 year parts warranty,auto parts 2 year warranty,parts supplier warranty,lifetime parts warranty",
  //     },
  //   },
  // };

  return (
    <PageContainer>

      <div className={`${styles.warranty_banner_image} m-t-10`}>
        <LandingPageBanner
          style={{ minHeight: isMobile ? "calc(41.1 * var(--safari-root-font, 10px))" : "calc(27.8 * var(--safari-root-font, 10px))" }}
          bannerImages={{
            mobileImage: getRelativeImagePath(`/cms/${responsiveBannerMedia?.squareImage?.url || responsiveBannerMedia?.mobile?.url}`),
            desktopImage: getRelativeImagePath(`/cms/${responsiveBannerMedia?.desktop?.url}`),
          }}
          {...{ width: 1340, height: 324 }}
          alt="warranty on auto parts"
        />
      </div>

      <div
        className="d-flex"
        style={{ justifyContent: "center", marginTop: "calc(2 * var(--safari-root-font, 10px))" }}
      >
        <h1>{headers.h1}</h1>
      </div>
      <div className={styles.container}>
        <ContentIdsComponent
          contentIds={contentIds}
          backgroundUrl={`url(${process.env.NEXT_PUBLIC_ROOT_URL}/images/home/partsavatar-title-icons.png)`}
          whiteBackground
          classNames="m-0 p-b-0 p-t-20"
        />
      </div>
    </PageContainer>
  );
}

export default memo(WarrantyPolicy);
